import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils.mjs';

function SvgIcRemoveFill(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4 13.25a1.25 1.25 0 1 1 0-2.5h16a1.25 1.25 0 1 1 0 2.5z"
  }));
}
var IcRemoveFill = createNolIcon(/*#__PURE__*/forwardRef(SvgIcRemoveFill));

export { IcRemoveFill as I };
